import goodMain from './goodMain.vue'
export default {
    goodMain 
}